// Tickable Mail texts, one file per area so the areas can be edited apart.
import common from "./common.nl"
import editor from "./editor.nl"
import flows from "./flows.nl"
import campaigns from "./campaigns.nl"
import inbox from "./inbox.nl"

export default { ...common, ...editor, ...flows, ...campaigns, ...inbox }
